// Qué tienda pasa a ser la PRINCIPAL de un staff cuando el owner desmarca la actual.
//
// Espeja la elección del backend (`update_staff`): la primera tienda marcada donde el
// trabajador YA estaba asignado; si no hay ninguna, la primera marcada. El número de socio
// viaja con ella (el backend lo re-numera), por eso el modal avisa antes de guardar.
export function nuevaTiendaPrincipal(staffData, selectedIds) {
  const marcadas = (selectedIds || []).map(String);
  const actual = staffData?.venue_id ? String(staffData.venue_id) : null;
  if (!actual || marcadas.length === 0 || marcadas.includes(actual)) return null;

  const previas = new Set(
    (Array.isArray(staffData?.assigned_venues) ? staffData.assigned_venues : [])
      .map((v) => String(typeof v === 'string' ? v : (v?.id ?? v)))
  );
  return marcadas.find((id) => previas.has(id)) ?? marcadas[0];
}
